// extracted by mini-css-extract-plugin
export default {"container":"-08Pm","details":"vzNuS"};